import { z } from 'zod';

export const BugBountyConnectionStatusBaseSchema = z.object({
  status: z.enum(['VALID', 'EXPIRED', 'REVOKED', 'NOT_CONNECTED']),
  providerUserId: z.string().nullable(),
  webhookUrl: z.string().nullable(),
});

export const BugBountyConnectResponseSchema = z.object({
  success: z.boolean(),
  webhookUrl: z.string(),
  webhookId: z.string(),
  webhookSecret: z.string().optional(),
});

export const BugBountyScanResultResponseSchema = z.object({
  success: z.boolean(),
  fetched: z.number(),
  published: z.number(),
});

export const BugcrowdScanTriggerResponseSchema = z.object({
  queued: z.literal(true),
});
